import React from 'react';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div>
            <h3 style={{ color: 'var(--primary-orange)', marginBottom: '15px' }}>☕ ChaiY</h3>
            <p style={{ color: '#9ca3af' }}>Started in 2022 to innovate in the food industry to serve authentic food with quality ingredients.</p>
          </div>
          <div>
            <h4>Quick Links</h4>
            <ul style={{ listStyle: 'none', lineHeight: '2' }}>
              <li><a href="/" style={{ color: '#9ca3af', textDecoration: 'none' }}>Home</a></li>
              <li><a href="/about" style={{ color: '#9ca3af', textDecoration: 'none' }}>About Us</a></li>
              <li><a href="#products" style={{ color: '#9ca3af', textDecoration: 'none' }}>Products</a></li>
            </ul>
          </div>
          <div>
            <h4>Contact Us</h4>
            <ul style={{ listStyle: 'none', lineHeight: '2', color: '#9ca3af' }}>
              <li>📍 Dahanukar Colony, Pune</li>
              <li>📞 8080673114</li>
              <li>⏰ Mon-Sun: 8 AM - 11 PM</li>
            </ul>
          </div>
        </div>
        <div style={{ textAlign: 'center', color: '#6b7280', borderTop: '1px solid #374151', paddingTop: '20px' }}>
          © 2026 ChaiY. All rights reserved. | Crafted for chai lovers
        </div>
      </div>
    </footer>
  );
};

export default Footer;